var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntermediateCircleLine = function SvgIntermediateCircleLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12m0-1.2a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6M5 7.4h6v1.2H5z"
  })));
};
export default SvgIntermediateCircleLine;